import React, {Component} from 'react';
import {Table} from './table';
import {connect} from 'react-redux';
import {MapProps, OwnProps} from './type';
import {styles, Classes} from './styles';
import {withStyles} from '@material-ui/core/styles';
import PeriodPicker from '../../components/period-picker';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import {SpinnerNoData} from '../../components';
import ErrorBoundary from '../../components/error-boundary';
import UserInfo from 'feedback-system/components/user-info';
import {getValueAuthor, getValueUser, getDerection, getValueTeam, feedbacksFilter} from './services/selectors';
import SearchUser from './search-user';
import {USER_ROLE} from 'feedback-system/modules/user-profile/constants';
import {Profile} from 'feedback-system/dto/IProfile';

import {
    getFeedbacksData,
    setFilterAuthor,
    setFilerRecipient,
    setFilerRecipientTeam,
    setDerection
} from './services/action';

type IProps = Classes & OwnProps;

interface State {
    user: Profile | null;
    periodId: number;
}

class FeedbackOverview extends Component<IProps, State> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            user: null,
            periodId: props.currentPeriod
        };
    }

    componentDidMount() {
        const {user, periodId} = this.state;
        this.props.getFeedbacksData(periodId, user);
    }

    setFilterUser = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.props.setFilerRecipient(e.target.value);
    }

    setFilterAuthor = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.props.setFilterAuthor(e.target.value);
    }

    sortingRating = (derection: string) => {
        this.props.setDerection(derection);
    }

    setFilterTeam = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.props.setFilerRecipientTeam(e.target.value);
    }

    handleCalendarPeriodChange = (id: number) => {
        const {user} = this.state;
        this.setState({
            periodId: id
        }, () => {
            this.props.getFeedbacksData(id, user);
        });
    }

    handleUserChange = (user: Profile) => {
        const {periodId} = this.state;
        this.setState({
            user
        }, () => {
            this.props.getFeedbacksData(periodId, user);
        });
    }

    handleClearUser = () => {
        const {periodId} = this.state;
        this.setState({
            user: null
        }, () => {
            this.props.getFeedbacksData(periodId, null);
        });
    }

    render() {
        const {classes, roles} = this.props;
        const {user} = this.state;
        return (
            <>
                <ErrorBoundary>
                    <div className={classes.pageHeader}>
                        {roles.includes(USER_ROLE.MANAGER) ?
                            <>
                                <SearchUser
                                    endpoint="profiles/leads"
                                    onUserChange={this.handleUserChange}
                                />
                                {user ? <div className={classes.userInfo}>
                                    <Typography variant={'h6'}>
                                        <UserInfo user={user} />
                                    </Typography>
                                    <IconButton
                                        className={classes.marginClearButton}
                                        onClick={this.handleClearUser}>
                                        <ClearIcon fontSize="small" />
                                    </IconButton>
                                </div> : null}
                            </> :
                            <Typography variant={'h6'}>
                                Feedback Overview
                            </Typography>
                        }
                        <PeriodPicker handlePeriodChange={this.handleCalendarPeriodChange}/>
                    </div>
                </ErrorBoundary>
                {this.props.feedbacksLength
                    ?
                    <>
                        <ErrorBoundary>
                            <Table
                                data={this.props.feedbacks}
                                authorFilter={this.props.authorFilter}
                                recipientFilter={this.props.recipientFilter}
                                sortingRating={this.sortingRating}
                                filterUser={this.setFilterUser}
                                derection={this.props.derection}
                                filterAuthor={this.setFilterAuthor}
                                filterTeam={this.setFilterTeam}
                                recipientTeamFilter={this.props.recipientTeamFilter}
                            />
                        </ErrorBoundary>
                    </>
                    :
                    <SpinnerNoData
                        loading={this.props.loading}
                        title="Feedback Overview"
                        message="There is no feedback"
                    />
                }
            </>
        );
    }
}

const mapStateToProps = (state: MapProps) => {
    const {statisticReducer, authenticated: {roles}, periods} = state;
    const {feedbacks, loading} = statisticReducer;
    return {
        feedbacks: feedbacksFilter(state),
        authorFilter: getValueAuthor(state),
        recipientFilter: getValueUser(state),
        recipientTeamFilter: getValueTeam(state),
        derection: getDerection(state),
        feedbacksLength: feedbacks.length,
        currentPeriod: periods.current.id,
        loading,
        roles
    };
};

const mapDispatchToProps = {
    getFeedbacksData,
    setFilterAuthor,
    setFilerRecipient,
    setFilerRecipientTeam,
    setDerection
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default withStyles(styles)(connector(FeedbackOverview));
